export const deepCopy = (object: Object | null) => JSON.parse(JSON.stringify(object));
